import { clearSessionalData, setQuestionnaire } from "../../../../../redux/user-slices/auth.slice"
import SectionSkeleton from "../../../../../components/ui/SectionSkeleton"
import { step1, step2, step3, step4, step5, step6, step7 } from "./data"
import TopBannerB from "../../../../../components/common/TopBannerB"
import { Suspense, useEffect, useRef, useState } from "react"
import { useToast } from "../../../../../hooks/useToast"
import Images from "../../../../../assets/js/Images"
import { Box, Container } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import StepButtons from "../StepButtons"
import GetStart from "./GetStart"
import Step from "../Step"

function Sessional() {
  const dispatch = useDispatch()
  const toast = useToast()
  const navigate = useNavigate()
  const formDataRef = useRef({})
  const [activeStep, setActiveStep] = useState(0)


  useEffect(() => {
    dispatch(clearSessionalData());
    // eslint-disable-next-line
  }, []);
  const handleOnChnage = (e) => {
    dispatch(setQuestionnaire(formDataRef.current));
    navigate("/matching-specialist", { state: e?.target?.value })
  }

  const stepsConfig = [
    {},
    { steps: step1 },
    { steps: step2 },
    { steps: step3 },
    { steps: step4 },
    { steps: step5 },
    { steps: step6 },
    { steps: step7, onChangeFun: handleOnChnage },
  ]

  const handleNext = () => {
    if (activeStep < (stepsConfig?.length - 1)) {
      setTimeout(() => {
        setActiveStep((prevStep) => prevStep + 1)
      }, 500)
    }
  }

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1)
  }
  const isStepValid = () => {
    const currentStepConfig = stepsConfig[activeStep];
    const currentQuestions = currentStepConfig?.steps || [];

    if (!currentQuestions.length) return true;

    for (const q of currentQuestions) {
      if (q.type === "multiselect") {
        const val = formDataRef.current[q.name];
        if (!Array.isArray(val) || val.length === 0) {
          return false;
        }
      } else {
        const val = formDataRef.current[q.name];
        if (!val || String(val).trim() === "") {
          return false;
        }
      }
    }
    return true;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault()
    const form = new FormData(e.target)
    const formData = Object.fromEntries(form)

    Object.keys(formData).forEach((key) => {
      if (formData[key]) {
        formDataRef.current[key] = formData[key];
      }
    });

    if (activeStep > 0 && !isStepValid()) {
      return toast.error("Please select an option before continuing.");
    }

    if (activeStep === stepsConfig.length - 1) {
      const selectedPref = formDataRef.current["recommendationPreference"];
      dispatch(setQuestionnaire(formDataRef.current));
      navigate("/matching-specialist", { state: selectedPref });
      return;
    }

    handleNext()
  }
  return (
    <>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerB
          bannerImg={Images?.getStarted1}
          headline="Great — you're in the right place."
          subHeadline="Let's make sure we connect you with exactly the right kind of support."
        />
      </Suspense>

      <Box
        component="section"
        sx={{ py: { xs: 5, lg: 10 } }}
      >
        <Container maxWidth={false} fixed>
          <Box sx={{ maxWidth: "600px", mx: "auto" }} component="form" onSubmit={handleSubmit}>
            {activeStep === 0 ?
              <GetStart handleNext={handleNext} /> :
              stepsConfig[activeStep] && (
                <Step
                  nextBtnFun={handleNext}
                  index={activeStep}
                  formData={formDataRef}
                  steps={stepsConfig[activeStep].steps}
                  onChangeFun={stepsConfig[activeStep].onChangeFun}
                />
              )
            }
            {!(activeStep === 0) &&
              <StepButtons
                nextBtnFun={handleNext}
                backBtnFun={handleBack}
                backBtn={activeStep > 1}
                skipBtn={activeStep <= stepsConfig?.length - 2}
                isLastStep={activeStep === stepsConfig?.length - 1}
              />
            }
          </Box>
        </Container>
      </Box>
    </>
  )
}

export default Sessional